/**
 * Popup Manager
 * Central component to manage and coordinate all popup types
 * Ensures only one popup shows at a time
 */

import React from 'react';
import ExitIntentPopup from './ExitIntentPopup';
import ScrollPopup from './ScrollPopup';
import TimedPopup from './TimedPopup';

export interface PopupManagerProps {
  enableExitIntent?: boolean;
  enableScroll?: boolean;
  enableTimed?: boolean;

  // Custom delays/thresholds
  exitIntentDelay?: number;
  scrollPercentage?: number;
  timedDelay?: number;
}

/**
 * Use this component once in your App or Layout to enable all popups
 *
 * Example:
 * <PopupManager
 *   enableExitIntent={true}
 *   enableScroll={true}
 *   enableTimed={true}
 * />
 */
const PopupManager: React.FC<PopupManagerProps> = ({
  enableExitIntent = true,
  enableScroll = true,
  enableTimed = true,
  exitIntentDelay = 5000,
  scrollPercentage = 60,
  timedDelay = 50000,
}) => {
  return (
    <>
      {/* Exit Intent Popup - Highest priority */}
      <ExitIntentPopup
        enabled={enableExitIntent}
        delay={exitIntentDelay}
      />

      {/* Scroll Popup - Medium priority */}
      <ScrollPopup
        enabled={enableScroll}
        scrollPercentage={scrollPercentage}
      />

      {/* Timed Popup - Lowest priority */}
      <TimedPopup
        enabled={enableTimed}
        delay={timedDelay}
      />
    </>
  );
};

export default PopupManager;
